import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';

interface ResendOfferOrderEmailButtonProps {
  id: string;
  confirmationEmail?: boolean;
  oversubscriptionEmail?: boolean;
  disabled?: boolean;
}

export const ResendOfferOrderEmailButton = ({
  id,
  confirmationEmail,
  oversubscriptionEmail,
  disabled,
}: ResendOfferOrderEmailButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { isLoading }] = useUpdate();

  const onResend = async () => {
    update(
      DataProviderResource.ResendOfferOrderEmail,
      {
        id,
        data: {
          confirmationEmail,
          oversubscriptionEmail,
        },
      },
      {
        onSuccess: () => {
          notify('Offer order resend email was successfully requested.', { type: 'success' });
        },
        onSettled: () => {
          refresh();
        },
        onError: err => {
          notify(`Failed to request offer order resend email: ${err}`, {
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <>
      <Button label={'Resend'} onClick={onResend} disabled={isLoading || disabled} style={{ marginTop: '8px' }}>
        <RestartAltIcon />
      </Button>
    </>
  );
};
